import React, { useState, useContext, useEffect } from 'react';
import base64 from 'base64-js';

import './File.css';
import Button from '../../../App/Common/Button/Button';

const File = ({ setAnswers, answers, currentAnswer, questionId }) => {
    // const [covers, setCovers] = useState(typeof attachment === 'string' ? [attachment] : attachment)
    const [files, setFiles] = useState([]);
    const [filenames, setFilenames] = useState([]);
    const [currentFilenames, setCurrentFilenames] = useState([]);
    const [link, setLink] = useState(typeof currentAnswer === 'string' ? currentAnswer : '');
    // console.log(currentAnswer);
    const handleFiles = (e) => {
        e.preventDefault();
        var newFiles = e.target.files;
        let filesArray = [...files];
        let filenamesArray = [...filenames];

        // console.log(newFiles)
        //console.log(10 - filenames.length)
        const limit =
            newFiles.length < 10 - filenames.length ? newFiles.length : 10 - filenames.length;
        if (newFiles) {
            for (let i = 0; i < limit; i++) {
                const reader = new FileReader();
                filenamesArray.push(newFiles[i].name);

                reader.onload = function () {
                    var content = base64.fromByteArray(new Uint8ClampedArray(reader.result));
                    filesArray.push(content);
                    //  console.log(filesArray)
                    setFiles(filesArray);
                };

                reader.readAsArrayBuffer(newFiles[i]);
            }
            setFilenames(filenamesArray);

            setLink('');
        } else {
            return;
        }
    };

    const handleLink = (value) => {
        setFiles([]);
        setFilenames([]);
        setLink(value);
    };
    useEffect(() => {
        setFiles([]);
        setFilenames([]);
        setLink('');
        setCurrentFilenames([]);
    }, [questionId]);

    useEffect(() => {
        setAnswers({
            files: files,
            filenames: filenames,
            third_party_url: link,
        });
    }, [files]);

    useEffect(() => {
        if (currentAnswer) {
            setLink(currentAnswer.third_party_url);
            if (typeof currentAnswer === 'object' && currentAnswer.length > 0) {
                setCurrentFilenames(currentAnswer.map((a) => a.filename));
                setFilenames([]);
            }
        }
    }, [currentAnswer]);

    const deletePreview = (index) => {
        let filesArray = [...files];
        let namesArray = [...filenames];
        filesArray.splice(index, 1);
        namesArray.splice(index, 1);
        setFilenames(namesArray);
        setFiles(filesArray);
    };
    const clearFileslist = () => {
        setCurrentFilenames([]);
    };

    const getDisplayFilename = (filename, maxLength = 15) => {
        const ext = filename.split('.').pop();
        const name = filename.slice(0, filename.lastIndexOf('.'));

        if (name.length <= maxLength) {
            return filename;
        }

        return `${name.slice(0, maxLength)}... .${ext}`;
    };

    return (
        <>
            <div className='file__wrap'>
                <div>
                    <div className='file__fields'>
                        <div>
                            <label
                                className={`file__label`}
                                onChange={(e) => handleFiles(e)}
                                htmlFor='file'
                            >
                                <Button
                                    buttonText={'Загрузить файл'}
                                    color={'#7A5AF8'}
                                    type={'filled'}
                                    disabled={
                                        currentFilenames.length > 0 ? true : filenames?.length > 9
                                    }
                                />
                            </label>
                            <div className='file__comments'>
                                <p className='file__capture'>
                                    doc, docx, pdf, jpeg, png, ppt, pptx
                                </p>
                                <p className='file__capture'>Не более 10 файлов</p>
                            </div>
                        </div>
                        <label
                            className={`file__label`}
                            onChange={(e) => handleFiles(e)}
                            htmlFor='file'
                        >
                            <div className='file__input_wrap'>
                                <p className='file__description'>
                                    Или перетащите сюда файл для загрузки
                                </p>
                                <input
                                    accept='.doc, .docx, .pdf, image/jpeg, image/png, .ppt, .pptx'
                                    className='file__input'
                                    type='file'
                                    id='file'
                                    name='file'
                                    max={10}
                                    disabled={
                                        currentFilenames.length > 0 ? true : filenames?.length > 9
                                    }
                                    multiple
                                />
                            </div>
                        </label>
                    </div>
                    {
                        <div className='linkInput__container'>
                            <div className='linkInput__comment'>Или загрузите видео по ссылке</div>
                            <div className='linkInput__input_wrap'>
                                <input
                                    className='linkInput__input'
                                    type='url'
                                    id='url'
                                    name='url'
                                    value={link}
                                    onChange={(e) => handleLink(e.target.value)}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className='file__previews_wrap'>
                    {filenames.length > 0 && (
                        <div className='file__previews'>
                            {filenames?.map((filename, index) => (
                                <div className='file__previewContainer' key={index}>
                                    <p className='file__preview'>
                                        {index + 1}. {getDisplayFilename(filename)}
                                    </p>
                                    <div
                                        className='file__deleteBtn'
                                        onClick={() => deletePreview(index)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                    {currentFilenames.length > 0 && (
                        <div className='file__previews'>
                            {currentFilenames.map((filename, index) => (
                                <div className='file__previewContainer' key={index}>
                                    <p className='file__preview'>
                                        {index + 1}. {getDisplayFilename(filename)}
                                    </p>
                                </div>
                            ))}
                            <div className='file__buttonContainer'>
                                <Button
                                    buttonText={'Заменить файлы'}
                                    onClickAction={clearFileslist}
                                    color={'#7A5AF8'}
                                    type={'filled'}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default File;
